import script from "./PostgraduateReport2023.vue?vue&type=script&setup=true&lang=js"
export * from "./PostgraduateReport2023.vue?vue&type=script&setup=true&lang=js"

import "./PostgraduateReport2023.vue?vue&type=style&index=0&id=25ed0f82&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ed0f82"]])

export default __exports__